import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projectExpense, nextProjectExpense }) =>
    present(
      repository
        .editProjectExpense(projectExpense, nextProjectExpense)
        .then((updatedProjectExpense) => ({
          projectExpense: updatedProjectExpense,
        }))
        .catch(() => Promise.reject({ projectExpense })),
    );
}

export type { Interactor };

export { createInteractor };
